<template>
  <div id="browse-arbitrary-search-overflow-hero" :data-theme="this.$store.state.chosenBrand">
    <div class="browse-filter-hero-component">
      <video autoplay="true" id="bg-hero-video" loop="true" muted="true" playsinline="true">
        <source :src="images.videoLink" type="video/mp4">
      </video>
      <div class="overlay-content">
        <div class="container container-sm">
          <div class="browse-step text-content">
            <div class="row">
              <div class="col-xs-12 text-content--flex">
                <h1 class="call-to-action text-left">Adventure Awaits</h1>
                <h2 class="call-to-action-subheader">Explore our lineup of 2025 models or shop used and find your next vehicle today.</h2>
              </div>
            </div>
            <div class="browse-step hp-btn-content">
              <div class="row">
                <div class="col-sm-4 home-block Explore">
                  <a href="#" class="track-click  btn btn-lg inventory-type-button-block" data-category="Home Page Actions" data-action="Explore">Shop Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="browse-overflow">
      <div class="browse-vehicles">
        <div class="container">
          <div class="row browse-row vehicle-browse-row">
            <div class="col-xs-12">
              <div class="vehicle-browse-ajax">
                <form action="/vehicles" class="vehicle-search-form" method="get">
                  <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle type:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                      <option data="true" value="new">New</option>
                      <option data="false" value="used">Used</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle year:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                      <option value="default">Year</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle make:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                      <option value="make">{{ brandName }}</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group">
                    <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle model:</label>
                    <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                      <option value="default">Model</option>
                    </select>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </div>
                  <div class="form-group" id="search-submit">
                    <input aria-label="Click here to submit" class="btn search-form-btn vehicle-search-submit" value="Search">
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  export default {
    props: ['images', 'logoURL'],
    data() {
      return {
        sideNavOpen: false,
        brand: this.$store.state.chosenBrand
      };
    },
    computed: {
      logoSRC () {
        if (this.brand === "mazda") {
          return require("../../static/images/common-icons/brand-logos/mazda-more-padding.png");
        } else {
          return this.images.logoExample[1];
        }
      },
      brandName () {
        if (this.brand === 'none') {
          return 'Brand';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      },
    },
    methods: {
      addOpen: function (e) {
        e.target.classList.add("open");
      },
      removeOpen: function (e) {
        e.target.classList.remove("open");
      },
      toggleSideNav: function () {
        this.sideNavOpen = !this.sideNavOpen;
      },
      closeSideNav: function () {
        this.sideNavOpen = false;
      }
    },
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style>
  #preview:has(#nav-right-with-contact-v-extended-toolbar) {
    margin-left: -9px;
    margin-right: -9px;
  }

  #browse-arbitrary-search-overflow-hero {
    --pc: var(--primary-color, #333333);
    --pcd: var(--primary-dark, #000000);
    --pcl: var(--primary-light, #ffffff);
  }

  #browse-arbitrary-search-overflow-hero {
    width: 100%;
    padding: 0;
    margin: 0 auto calc(1% + 30px) auto;
    position: relative;
  }

  #browse-arbitrary-search-overflow-hero .browse-filter-hero-component .container-sm {
    width: 100%;
    max-width: 720px;
  }

  #browse-arbitrary-search-overflow-hero .browse-filter-hero-component {
    position: relative;
    overflow: hidden;
    min-height: 500px;
  }

  #browse-arbitrary-search-overflow-hero .bg-layer[style=""] {
    background-color: var(--pcd);
  }

  #browse-arbitrary-search-overflow-hero .browse-step .text-content--flex {
    display: flex;
    flex-flow: column-reverse nowrap;
  }

  #browse-arbitrary-search-overflow-hero .browse-step .call-to-action {
    color: #ffffff;
    font-size: 5rem;
  }

  #browse-arbitrary-search-overflow-hero .browse-step .call-to-action-subheader {
    font-size: 2rem;
    color: #ffffff;
  }

  #browse-arbitrary-search-overflow-hero .bg-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    transition: background 1s ease-in-out;
  }

  #browse-arbitrary-search-overflow-hero #bg-hero-video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  #browse-arbitrary-search-overflow-hero .overlay-content {
    color: #ffffff;
    bottom: 0;
    left: 0;
    animation: 1.5s ease-in 0s;
    position: absolute;
    min-height: 500px;
    background-blend-mode: multiply;
    background-color: rgb(0 0 0 / 0.3);
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  #browse-arbitrary-search-overflow-hero .text-content {
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }

  #browse-arbitrary-search-overflow-hero .hp-btn-content .home-block {
    padding: 0 5px;
  }

  #browse-arbitrary-search-overflow-hero .inventory-type-button-block {
    padding: 15px;
    background-color: transparent;
    border: 3px solid #ffffff;
    font-size: 16px;
    color: #ffffff;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    -moz-transition: all 0.3s ease;
    transition: .3s all ease;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: var(--brand-br, 4px);
    width: 100%;
  }

  #browse-arbitrary-search-overflow-hero .hp-btn-content {
    padding: 25px 15px 0;
  }

  #browse-arbitrary-search-overflow-hero .hp-btn-content--quad {
    padding: 25px 0;
  }

  #browse-arbitrary-search-overflow-hero .inventory-type-button-block:hover {
    background-color: var(--pcl);
    color: var(--pc);
  }

  #browse-arbitrary-search-overflow-hero .search-bar-content {
    margin: 0 auto 25px;
  }

  #browse-arbitrary-search-overflow-hero .hp-btn-content--quad + .search-bar-content {
    margin: 0 auto 35px;
  }

  #browse-arbitrary-search-overflow-hero .search-bar-content .search-submit-btn {
    color: var(--pc);
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    -moz-transition: all 0.3s ease;
    transition: .3s all ease;
  }

  #browse-arbitrary-search-overflow-hero .search-bar-content .search-submit-btn:hover {
    background-color: var(--pc);
    color: #ffffff;
    border-color: var(--pc);
  }

  #browse-arbitrary-search-overflow-hero .dropdown-search-filter {
    position: absolute;
    top: calc(100% - 35px);
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 60px);
    max-width: 1024px;
    padding: 15px;
    border-radius: 3px;
    background-color: #ffffff;
    -moz-box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
    -webkit-box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
    box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
  }

  /* NEW ADDS */
  #browse-arbitrary-search-overflow-hero .text-content {
    height: 68vh;
  }

  #browse-arbitrary-search-overflow-hero .overlay-content {
    height: 68vh;
    position: relative;
  }

  /* copied from search hero with overflow component */
  #browse-arbitrary-search-overflow-hero .browse-overflow {
    margin: -60px auto 0px !important;
    z-index: 8;
    padding-bottom: 30px;
    overflow: visible;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-size: cover;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax {
    width: 100%;
    max-width: 1024px;
    margin: auto auto 20px;
    padding: 15px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0px 0px 16px rgb(16 16 16 / 26%);
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group {
    flex: 0 0 20%;
    position: relative;
    margin-bottom: 0px;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group:not(#search-submit) {
    background-color: #fff;
    line-height: 32px;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group i {
    position: absolute;
    line-height: 40px;
    right: 12px;
    top: 0;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-control {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    z-index: 1;
    background-color: transparent;
    border: none;
    border-radius: 0px;
    box-shadow: none;
    padding: 6px 12px 6px 0px;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 2px;
    font-size: 13px;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 2px;
    padding: 12px 0px;
    font-size: 13px;
    width: 100%;
    max-width: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit:hover {
    opacity: .7;
  }

  @media (max-width: 575px) {
    html #browse-arbitrary-search-overflow-hero .browse-filter-hero-component, 
    html #browse-arbitrary-search-overflow-hero .overlay-content {
      min-height: 300px;
    }
  }

  @media (min-width: 385px) {
    html #browse-arbitrary-search-overflow-hero .overlay-content,
    #browse-arbitrary-search-overflow-hero .text-content {
      height: 75vh;
    }
  }

  @media (min-width: 768px) {
    html #browse-arbitrary-search-overflow-hero .overlay-content,
    #browse-arbitrary-search-overflow-hero .text-content {
      height: 58.5vh;
    }
  }

  /* HP Animation in Hero */

  html #browse-arbitrary-search-overflow-hero .browse-step .call-to-action-subheader,
  #browse-arbitrary-search-overflow-hero .hp-btn-content, 
  #browse-arbitrary-search-overflow-hero .browse-step.search-bar-content,
  html #browse-arbitrary-search-overflow-hero .browse-step .call-to-action {
      animation: 1.5s ease-in 0s contentLayerFadeIn;
  }
  @keyframes contentLayerFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @media (max-width: 767px) {
    body #browse-arbitrary-search-overflow-hero .text-content {
      padding-bottom: 30px;
    }
  }

  /* INFINITI */
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-step .text-content--flex {
    text-align: left;
    flex-flow: column;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-filter-hero-component .container-sm {
    margin-left: 0;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .overlay-content {
    justify-content: end;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .overlay-content .hp-btn-content .row {
    justify-content: start;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .text-content {
    justify-content: end;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-step .call-to-action {
    font-size: 4rem;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-step .call-to-action-subheader {
    font-size: 16px;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .inventory-type-button-block {
    font-size: 16px;
  }
  #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-overflow {
    display: none;
  }

  @media (min-width: 992px) {

    #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-step .call-to-action-subheader {
      margin-bottom: 0;
    }
    #browse-arbitrary-search-overflow-hero[data-theme="hyundai"] .browse-step .call-to-action {
      font-size: 4rem;
      text-align: center;
    }

  }

  @media (max-width: 991px) {

    #browse-arbitrary-search-overflow-hero .browse-step .call-to-action {
      font-size: 3.5rem;
      max-width: 90%;
      margin: auto;
    }
    #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .browse-step .call-to-action {
      width: 100%;
      margin: 0;
    }

    #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
      padding: 10px 0px;
    }
    #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group i {
      line-height: 37px;
    }

  }

  @media (min-width: 768px) {

    #browse-arbitrary-search-overflow-hero .overlay-content .hp-btn-content .row {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
    }

    #browse-arbitrary-search-overflow-hero .hp-btn-content--quad + .search-bar-content .row .col-xs-12,
    #browse-arbitrary-search-overflow-hero :not(.hp-btn-content--quad) + .search-bar-content {
      padding: 0 5px;
    }

    #browse-arbitrary-search-overflow-hero .hp-btn-content--quad + .search-bar-content, 
    #browse-arbitrary-search-overflow-hero .hp-btn-content--quad {
      max-width: 540px;
      margin: auto;
    }
    #browse-arbitrary-search-overflow-hero .browse-row {
      padding: 0 15px;
    }
    #browse-arbitrary-search-overflow-hero .vehicle-search-form {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
    }
    #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group {
      flex-basis: 20%;
      max-width: 20%;
    }
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(1), 
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(2), 
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(3) {
      margin-right: 0px !important;
      border-right: 1px solid #999999;
    }
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(4) {
      padding-right: 12px;
    }
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(4) i {
      right: 24px;
    }

  }

  @media (max-width: 767px) {

    #browse-arbitrary-search-overflow-hero .browse-filter-hero-component .container-sm {
      width: 100%;
      max-width: 100%;
      padding: 0 30px;
    }

    #browse-arbitrary-search-overflow-hero .browse-filter-hero-component,
    #browse-arbitrary-search-overflow-hero .overlay-content {
      min-height: 650px;
    }

    #browse-arbitrary-search-overflow-hero .hp-btn-content .home-block {
      margin: auto;
      padding: 0 15px;
    }

    #browse-arbitrary-search-overflow-hero .overlay-content {
      justify-content: flex-end;
      background-color: rgb(0 0 0 / 0.5);
    }

    #browse-arbitrary-search-overflow-hero .browse-step .call-to-action {
      font-size: 2.5rem;
      max-width: 100%;
      margin-left: 0;
    }

    #browse-arbitrary-search-overflow-hero .browse-step .call-to-action-subheader {
      font-size: 1.5rem;
    }

    #browse-arbitrary-search-overflow-hero .inventory-type-button-block {
      margin-bottom: 15px
    }

    #browse-arbitrary-search-overflow-hero .hp-btn-content {
      padding: 15px 0;
    }

    #browse-arbitrary-search-overflow-hero .text-content {
      text-align: left;
    }

    #browse-arbitrary-search-overflow-hero .dropdown-search-filter {
      padding-top: 10px;
      width: 100%;
      max-width: none;
      position: static;
      -ms-transform: none;
      -webkit-transform: none;
      transform: none;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      max-width: 100%;
      margin: auto;
      padding: 10px 30px;
    }

    #browse-arbitrary-search-overflow-hero[data-theme="kia"] .browse-filter-hero-component,
    #browse-arbitrary-search-overflow-hero[data-theme="kia"] .overlay-content {
	    min-height: 300px;
    }

    #browse-arbitrary-search-overflow-hero .col-xs-12 .vehicle-browse-ajax {
      max-width: 360px !important;
    }
    #browse-arbitrary-search-overflow-hero .form-group {
      max-width: 300px;
      margin: auto;
    }
    #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .form-group:not(:last-child) {
      padding-top: 6px;
      padding-bottom: 6px;
      margin-bottom: 6px;
    }
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(1), 
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(2), 
    #browse-arbitrary-search-overflow-hero .form-group:nth-of-type(3) {
      margin-bottom: 6px !important;
      border-bottom: 1px solid #999999;
    }
    #browse-arbitrary-search-overflow-hero .vehicle-browse-ajax .search-form-btn.vehicle-search-submit {
      padding: 15px 0px;
    }

  }

  @media (min-width: 576px) and (max-width: 767px) {

    #browse-arbitrary-search-overflow-hero .overlay-content .hp-btn-content .row {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
    }

    #browse-arbitrary-search-overflow-hero .hp-btn-content .home-block {
      width: 50%;
    }

    #browse-arbitrary-search-overflow-hero[data-theme="infiniti"] .hp-btn-content .home-block {
      margin-left: 0;
    }
  }
</style>